/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.initAddresses = function() {
  $.each($('.resident-wrapper input[id$="resident"]'), function(index) {
    return showResidentMonths(this);
  });

  const $addresses = $('.addresses');

  // Use namespaced events so re-init on turbo:load doesn't accumulate duplicate handlers
  $addresses.off('.addresses')
    .on('click.addresses', 'input[id$="resident"]', function(event) {
      return showResidentMonths(this);
    })
    .on('change.addresses', '.address-picker', function(event) {
      $(this).closest('.address').find('.web-geocode').val('');
      return updateUI();
    })
    .on('keyup.addresses', '.address-picker', event => updateUI())
    .on('click.addresses', '.add-address', function(event) {
      event.preventDefault();
      addAddress();
      return false;
    })
    .on('click.addresses', '.review-addresses .review-address-action a.edit', function(event) {
      event.preventDefault();
      showEditAddress();
      return false;
    })
    .on('click.addresses', '.cancel-edit a', function(event) {
      event.preventDefault();
      const $address = findAddress(this);
      cancelEditAddress($address);
      restoreAddressLocation($address);
      return false;
    })
    .on('click.addresses', '.incorrect-map a', function(event) {
      event.preventDefault();
      editAddress(this);
      return false;
    })
    .on('click.addresses', '.not-recognized a', function(event) {
      event.preventDefault();
      const $address = editAddress(this); // FIXME
      $address.find('.raw-property-address').addClass('highlight');
      $address.find('.unit-property-address').addClass('highlight');
      $address.find('.field_with_errors span.error').remove();
      $address.find('.field_with_errors').removeClass('field_with_errors');
      return false;
    })
    .on('click.addresses', 'a.remove:not(.disabled)', function(event) {
      event.preventDefault();
      if (confirm("Are you sure?")) {
        const $address = findAddress(this);
        if ($address.hasClass('primary')) {
          $address.find('input.raw-property-address').val('');
          $address.find('.map').hide();
        } else {
          removeAddress($address);
        }
        setTimeout(updateUI);
      }
      return false;
    })
    .on('click.addresses', 'a.make-primary:not(.disabled)', function(event) {
      event.preventDefault();
      makeAddressPrimary(findAddress(this));
      return false;
    });

  $('.addresses form, #addresses form')
    .off('submit.addresses')
    .on('submit.addresses', function() {
      const obj = $(this);
      return obj.find('.address.secondary').each(function() {
        const $address = findAddress(this);
        if ($address.find('input[name$="[raw]"]').val().trim().length === 0) { return $address.remove(); }
      });
    });

  if ($('#addresses .form-wrapper .addresses .error').length) {
    showEditAddress();
  }

  return initAddressMaps();
};

root.addAddress = function() {
  let $address = $('.addresses .address:hidden:last');
  $address = $address.clone(true).insertBefore($address).show();
  const count = $('.addresses .address:visible').length;

  // Reindex
  $address.find('input, select, label').each(function(n, el) {
    if (el.name != null) { el.name = replaceIndex(el.name, count); }
    if (el.id != null) { el.id = replaceIndex(el.id, count); }
    if (el.for != null) { return el.for = replaceIndex(el.for, count); }
  });
  // clone(true) copies the jQuery data store, including the 'autocomplete'
  // instance the addAutoComplete guard keys on — clear it so the cloned row gets
  // a fresh Autocomplete bound (mirrors the data('map'/'marker', false) reset below).
  $address.find('.address-picker').removeData('autocomplete');
  addAutoComplete($address.find('.address-picker'));

  // Reinit cloned map
  $address.find('.address-map').data('map', false);
  $address.find('.address-map').data('marker', false);
  initAddressMap($address.find('.address-map').html(''));

  return updateUI();
};

var makeAddressPrimary = function($fromAddress) {
  const $primaryAddress = $('.address.primary');
  const $primaryRawAddress = $primaryAddress.find('input.raw-property-address');

  if (!!$primaryRawAddress.val() && !confirm("Are you sure?")) { return; }

  // Switch all values
  const primaryIndex = $primaryRawAddress[0].name.match(/\[(\d+)\]/)[1];
  $fromAddress.find('input:not(.primary)').each(function(n, el) {
    if (el.name.includes('[resident]')) { return; }
    const $target = $primaryAddress.find('input[name="' + el.name.replace(/\[\d+\]/, '[' + primaryIndex + ']') + '"][type="' + el.type + '"]');
    if (!($target.length > 0)) { return; }
    const $el = $(el);
    const disabled = $el.prop('disabled');
    $el.prop('disabled', $target.prop('disabled'));
    $target.prop('disabled', disabled);
    if (el.type === 'checkbox') {
      const checked = $el.prop('checked');
      $el.prop('checked', $target.prop('checked'));
      return $target.prop('checked', checked);
    } else {
      const val = $el.val();
      $el.val($target.val());
      return $target.val(val);
    }
  });

  const hasClassEdit = $primaryAddress.hasClass('edit');
  $primaryAddress.toggleClass('edit', $fromAddress.hasClass('edit'));
  $fromAddress.toggleClass('edit', hasClassEdit);

  // When reading from the DB value, the coordinates are in reverse order
  // When reading from a web geocoded value, the coordinates are in the right order
  const coordsFrom = JSON.parse($fromAddress.find('input.location').val());
  const coordsPrimary = JSON.parse($primaryAddress.find('input.location').val());

  if (Array.isArray(coordsPrimary)) {
    updateMapMarkerLocation($primaryAddress, new google.maps.LatLng(...Array.from(coordsPrimary.reverse() || [])));
  } else {
    updateMapMarkerLocation($primaryAddress, new google.maps.LatLng(coordsPrimary));
  }

  if (Array.isArray(coordsFrom)) {
    return updateMapMarkerLocation($fromAddress, new google.maps.LatLng(...Array.from(coordsFrom.reverse() || [])));
  } else {
    return updateMapMarkerLocation($fromAddress, new google.maps.LatLng(coordsFrom));
  }
};

var showResidentMonths = function(elmt) {
  const obj = $(elmt);
  const checked = obj.prop('checked');
  const wrapper = obj.parents('.resident-wrapper');
  const residentMonths = $('.resident-months', wrapper);
  if (checked) {
    return residentMonths.removeClass("hidden");
  } else {
    return residentMonths.addClass("hidden");
  }
};

var showEditAddress = function() {
  $('.review-addresses').hide();
  return $('.edit-addresses').show();
};

root.editAddress = function(address) {
  const $address = findAddress(address);

  if ($address.hasClass('edit')) { return; }

  $address.addClass('edit');
  $address.find('input.use-manual-location').val('true');
  $address.find('input.web-geocode').val('');
  $address.find('input.location').prop('disabled', false);

  const mapDiv = $address.find('.address-map');
  const marker = mapDiv.data('marker');

  if (marker) {
    marker.setDraggable(true);
    mapDiv.data('markerPositionListener', marker.addListener('dragend', function() {
      $address.find('input.location').val(JSON.stringify(marker.position.toJSON()));
      return geocodeAddressLocation($address, {location: marker.position, resultType: 'political'});
    })
    );

    return $address.find('input.location').val(JSON.stringify(marker.position.toJSON()));
  }
};

root.cancelEditAddress = function(address) {
  const $address = findAddress(address);

  if (!$address.hasClass('edit')) { return; }

  $address.removeClass('edit');
  $address.find('input.use-manual-location').val('');
  $address.find('input.location').prop('disabled', true);

  const mapDiv = $address.find('.address-map');

  const marker = mapDiv.data('marker');
  if (marker != null) {
    marker.setDraggable(false);
  }

  return google.maps.event.removeListener(mapDiv.data('markerPositionListener'));
};

var restoreAddressLocation = function(address) {
  const $address = findAddress(address);
  const value = $address.find('input.address-picker').val();
  return geocodeAddressLocation($address, {address: value});
};

var geocodeAddressLocation = function($address, args) {
  $address = findAddress($address);

  const {
    location
  } = args;
  const {
    resultType
  } = args;
  delete args.resultType;

  const map = $address.find('.address-map').data('map');

  return new google.maps.Geocoder().geocode(args, function(results, status) {
    if (status === 'OK') {
      const result = results.find(result => !resultType || result.types.includes(resultType));
      if (location) { result.geometry.location = location; }
      if (location) { result.geometry.viewport = map.boundsAt(map.getZoom(), location); }
      return setAddressLocation($address, result);
    } else {
      return console.error('Geocode was not successful for the following reason: ' + status);
    }
  });
};

root.setAddressLocation = function(address, place) {
  const $address = findAddress(address);

  $address.find('input.location').val(JSON.stringify(place.geometry.location.toJSON()));
  $address.find('input.web-geocode').val(JSON.stringify({
    address_components: place.address_components,
    formatted_address: place.formatted_address,
    geometry: place.geometry
  })
  );

  updateMapMarkerLocation($address, place.geometry.location);
  return updateZoom($address);
};

var updateZoom = function(address) {
  const $address = findAddress(address);
  const $mapDiv = $address.find('.address-map');
  const map = $mapDiv.data('map');
  if (!map) { return; }
  map.setZoom(15);
  return setTimeout((() => map.setZoom(15)), 1);
};

var updateMapMarkerLocation = function(address, location) {
  const $address = findAddress(address);

  const $mapDiv = $address.find('.address-map');

  if (!($mapDiv.length > 0)) { return; }

  // Init map if necessary
  initAddressMap($mapDiv);

  const map = $mapDiv.data('map');
  let marker = $mapDiv.data('marker');
  if (!marker) {
    marker = new google.maps.Marker({ map, position: location });
    $mapDiv.data('marker', marker);
  } else {
    marker.setPosition(location);
  }

  map.panTo(location);

  if (!map.getZoom() || (map.getZoom() < 13)) { map.setZoom(15); }

  return $address.find('.map').removeClass('invalid').show();
};

var removeAddress = function(address) {
  const $address = findAddress(address);
  $address.find('input[name$="[_destroy]"]').val('1');
  $address.hide();
  return updateUI();
};

var updateUI = function() {
  $('.add-address').prop('disabled', $('.raw-property-address:visible').filter((n, i) => i.value === '').length > 0);
  $('.primary .remove').toggleClass('disabled', $('.primary .raw-property-address').val() === '');
  if ($('.primary .raw-property-address').val() === '') { $('.primary .map').hide(); }
  return $('.make-primary').each((n, i) => $(i).toggleClass('disabled', $(i).closest('.address').find('.raw-property-address').val() === ''));
};

var findAddress = function(address) {
  if (typeof address === 'string') { address = $('.address[data-address-id=' + address + ']'); }
  let $address = $(address);
  if (!$address.hasClass('.address')) { $address = $address.closest('.address'); }
  return $address;
};

var replaceIndex = function(text, index) {
  if (!text) { return; }
  text = text.replace(/^user\[addresses_attributes\]\[\d+\]/, 'user[addresses_attributes][' + index + ']');
  text = text.replace(/^user_addresses_attributes_\d+/, 'user_addresses_attributes_' + index);
  return text;
};


function initAddressesOnLoad() {
  if ($('.addresses, #addresses').length) {
    initAddresses();
    return updateUI();
  }
}

$(initAddressesOnLoad);
document.addEventListener('turbo:load', initAddressesOnLoad);
